import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Icon } from "@/components/kit";
import { api, proLink } from "@/api";

export default function ProLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let done = false;
    (async () => {
      try {
        await api.publicPro(slug);
        proLink.set(slug);
        proLink.markRedirect();
        if (!done) navigate("/", { replace: true });
      } catch (e) {
        proLink.clear();
        if (!done) navigate("/", { replace: true });
      }
    })();
    return () => { done = true; };
  }, [slug, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <Icon name="loader" size={36} className="animate-spin text-brand" />
    </div>
  );
}
